document.addEventListener('DOMContentLoaded', function() {
  // Close popup functionality
  const closeButton = document.querySelector('.close-popup');
  if (closeButton) {
    closeButton.addEventListener('click', hideLoginPopup);
  }

  // Close on outside click
  window.addEventListener('click', (e) => {
    const popup = document.getElementById('loginRegisterPopup');
    if (e.target === popup) {
      hideLoginPopup();
    }
  });

  // Handle hash changes
  window.addEventListener('hashchange', handleHashChange);
  handleHashChange(); // Handle initial hash

  // Handle login form
  const loginForm = document.querySelector('#loginTab form[action="/account/login"]');
  if (loginForm) {
    const loginButton = loginForm.querySelector('.submit-button');
    const loginInputs = loginForm.querySelectorAll('input[type="email"], input[type="password"]');
    
    loginInputs.forEach(input => {
      input.addEventListener('input', () => {
        const isFormFilled = Array.from(loginInputs).every(input => input.value.trim() !== '');
        loginButton.classList.toggle('active', isFormFilled);
      });
    });
  }

  // Handle register form
  const registerForm = document.querySelector('#registerTab form[action="/account/register"]');
  if (registerForm) {
    const registerButton = registerForm.querySelector('.submit-button');
    const registerInputs = registerForm.querySelectorAll('input[type="text"], input[type="email"], input[type="password"]');
    
    registerInputs.forEach(input => {
      input.addEventListener('input', () => {
        const isFormFilled = Array.from(registerInputs).every(input => input.value.trim() !== '');
        registerButton.classList.toggle('active', isFormFilled);
      });
    });
  }

  // Handle recover password form
  const recoverForm = document.querySelector('.recover-password-form form');
  if (recoverForm) {
    const recoverButton = recoverForm.querySelector('.submit-button');
    const recoverInput = recoverForm.querySelector('input[type="email"]');
    
    recoverInput.addEventListener('input', () => {
      recoverButton.classList.toggle('active', recoverInput.value.trim() !== '');
    });

    // Handle form submission to capture email for success message
    recoverForm.addEventListener('submit', function() {
      const emailInput = this.querySelector('input[name="email"]');
      if (emailInput && emailInput.value) {
        // Store the email in sessionStorage to display it in the success message
        sessionStorage.setItem('resetPasswordEmail', emailInput.value);
      }
    });
  }

  // Display the submitted email in the success message if available
  const submittedEmailSpan = document.getElementById('submitted-email');
  const submittedEmailPopupSpan = document.getElementById('submitted-email-popup');
  
  if (submittedEmailSpan || submittedEmailPopupSpan) {
    const storedEmail = sessionStorage.getItem('resetPasswordEmail');
    if (storedEmail) {
      if (submittedEmailSpan) submittedEmailSpan.textContent = storedEmail;
      if (submittedEmailPopupSpan) submittedEmailPopupSpan.textContent = storedEmail;
      // Clear the stored email
      sessionStorage.removeItem('resetPasswordEmail');
    } else {
      // Fallback text if no email is stored
      if (submittedEmailSpan) submittedEmailSpan.textContent = 'your email address';
      if (submittedEmailPopupSpan) submittedEmailPopupSpan.textContent = 'your email address';
    }
  }

  // Check if password reset success message is visible in popup and hide header
  const popupPasswordResetSuccess = document.querySelector('.recover-password-form .password-reset-success');
  if (popupPasswordResetSuccess && popupPasswordResetSuccess.closest('.recover-password-form').style.display !== 'none') {
    const header = document.querySelector('.popup-header');
    if (header) {
      header.style.display = 'none';
    }
  }

  // Handle form submissions
  const forms = document.querySelectorAll('#loginRegisterPopup form');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      // Prevent double submissions
      if (this.classList.contains('form-submitting')) {
        e.preventDefault();
        return;
      }
      
      // Add submitting class to show loader
      this.classList.add('form-submitting');
      
      // Disable submit button
      const submitBtn = this.querySelector('.submit-button');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
        submitBtn.style.cursor = 'not-allowed';
      }
    });
  });
});

function handleHashChange() {
  const hash = window.location.hash.toLowerCase();
  if (hash === '#login' || hash === '#signup') {
    showLoginPopup(hash.substring(1));
  }
}

function showLoginPopup(tab = 'login') {
  // Check if we're on the standalone login/register pages
  const currentPath = window.location.pathname;
  if (currentPath === '/account/login' || currentPath === '/account/register') {
    // If on login page and trying to register, redirect to register page
    if (currentPath === '/account/login' && tab === 'signup') {
      window.location.href = '/account/register';
      return;
    }
    // If on register page and trying to login, redirect to login page
    if (currentPath === '/account/register' && tab === 'login') {
      window.location.href = '/account/login';
      return;
    }
    // If already on the correct page, do nothing
    return;
  }

  // Otherwise show the popup as normal
  const popup = document.getElementById('loginRegisterPopup');
  if (popup) {
    popup.style.display = 'flex';
    switchTab(tab === 'signup' ? 'register' : 'login');
    window.location.hash = tab;
  }
}

function hideLoginPopup() {
  const popup = document.getElementById('loginRegisterPopup');
  const message = document.getElementById('googleLoginMessage');
  if (popup) {
    popup.style.display = 'none';
    if (message) {
      message.style.display = 'none';
    }
    // Clear the hash when closing the popup
    if (window.location.hash === '#login' || window.location.hash === '#signup') {
      history.pushState('', document.title, window.location.pathname + window.location.search);
    }
  }
}

function switchTab(tabId) {
  // Update tab buttons
  document.querySelectorAll('#loginRegisterPopup .tab-button').forEach(button => {
    button.classList.remove('active');
    if (button.textContent.toLowerCase().includes(tabId)) {
      button.classList.add('active');
    }
  });

  // Update tab contents
  document.querySelectorAll('#loginRegisterPopup .pop-tab-content').forEach(content => {
    content.style.display = 'none';
  });
  document.getElementById(tabId + 'Tab').style.display = 'block';

  // Update hash based on tab
  const hash = tabId === 'register' ? 'signup' : 'login';
  if (window.location.hash.toLowerCase() !== `#${hash}`) {
    window.location.hash = hash;
  }
}

function showRecoverPassword(event) {
  event.preventDefault();
  document.querySelector('.recover-password-form').style.display = 'block';
  document.querySelector('#loginTab form[action="/account/login"]').style.display = 'none';
}

function hideRecoverPassword() {
  document.querySelector('.recover-password-form').style.display = 'none';
  document.querySelector('#loginTab form[action="/account/login"]').style.display = 'block';
  // Show header when going back to login
  const header = document.querySelector('.popup-header');
  if (header) {
    header.style.display = 'block';
  }
}

function handleGoogleLogin(event) {
  event.preventDefault();
  const message = document.getElementById('googleLoginMessage');
  if (message) {
    message.style.display = 'block';
    setTimeout(() => {
      message.style.display = 'none';
    }, 3000); // Hide after 3 seconds
  }
}

function togglePassword(button) {
  const input = button.parentElement.querySelector('input');
  const isShowing = button.classList.contains('showing');
  
  if (isShowing) {
    input.type = 'password';
    button.classList.remove('showing');
  } else {
    input.type = 'text';
    button.classList.add('showing');
  }
}